// import NetInfo, { NetInfoState } from '@react-native-community/netinfo';
import { JsonObj } from '@mhp/general-interface';
import { Thunk } from 'store/types';

export const UPDATE_NETWORK_STATE = 'NETWORK.UPDATE_NETWORK_STATE' as const;

export const updateNetworkState = (status: JsonObj) => ({
  type: UPDATE_NETWORK_STATE,
  payload: status
});

export const getNetworkState = (): Thunk => async () => {
  // const state = await NetInfo.fetch();
  // dispatch(updateNetworkState(state));
};

export type NetworkAction = ReturnType<typeof updateNetworkState>;
